import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

const config = {
  types: [
    {
      title: 'sm',
      isDefault: true
    },
    'md',
    'lg'
  ],
  modifiers: ['picture', 'action']
}

const renderNotication = (notificationCount) => {
  notificationCount = Number(notificationCount)

  if (notificationCount === 0) return ''
  let content = ''
  if (notificationCount > 0 && notificationCount <= 9) {
    content = notificationCount
  } else if (notificationCount > 9) {
    content = '+9'
  }
  return (
    <div className="mdn-Avatar-notification mdn-Avatar-notification">
      {content}
    </div>
  )
}

export default function Avatar(props) {
  const { imageSrc, imageAlt, notificationCount, sm, md, lg, ...rest } = props

  let spanClassName = 'sm'
  if (md) {
    spanClassName = 'md'
  } else if (lg) {
    spanClassName = 'lg'
  }
  return (
    <div {...rest} className={resolveProps(props, config, 'Avatar')}>
      {imageSrc ? (
        <div className="mdn-Avatar-image">
          <img
            src={imageSrc || (config && config.imageSrc)}
            alt={imageAlt || (config && config.imageAlt)}
            role="img"
          />
        </div>
      ) : (
        <span
          className={
            'mdn-Avatar-icon mdn-Icon-minha-claro mdn-Icon--' + spanClassName
          }
        ></span>
      )}
      {(notificationCount || (config || {}).notificationCount) &&
        renderNotication(notificationCount || config.notificationCount)}
    </div>
  )
}
Avatar.propTypes = {
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
  notificationCount: PropTypes.number,
  sm: PropTypes.bool,
  md: PropTypes.bool,
  lg: PropTypes.bool,
  config: PropTypes.object,
  picture: PropTypes.bool
}
